import React, { useState, useEffect } from "react";
import formatAmount from "../../../../../helpers/formatAmount";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import BUDGET_API from "../../../../../apis/budget.api";
import moment from "moment";
export const DivorceBudget = ({ loading }) => {
  const [totalData, setTotalData] = useState({});
  const getAllBudgets = async () => {
    try {
      // setLoading(true);
      const date = moment();
      // const startDate = date.clone().subtract(12, "months").startOf("month").format("YYYY-MM-DD")
      const startDate = date.startOf("month").format("YYYY-MM-DD");
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      const data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);
        const promises =
          data.categorized &&
          data.categorized.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId, // Send categoryId for this budget
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                budget,
                response,
              })
            );
          });

        const results = await Promise.all(promises);

        const structuredData = results.map(({ budget, response }) => {
          console.log("Structured Data:", response);

          const usedAmount = response.currentMonthTransactions.totalAmount || 0;
          const totalAmount = budget.divorceBudgetAmount || budget.amount || 0;
          const totalDivorceAmount = budget.postDivorceBudget || 0;
          const newMonthlyBudget = totalDivorceAmount
            ? totalDivorceAmount - totalAmount
            : 0;
          const leftAmount = totalAmount - usedAmount;
          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget.budgetCategory && budget.budgetCategory.categoryName) ||
              "",
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            usedAmount,
            leftAmount,
            totalAmount,
            totalDivorceAmount,
            newMonthlyBudget,
          };
        });
        console.log("Structured Data:", structuredData);
        const totalUsedAmount =
          structuredData.reduce((total, data) => {
            return total + data.usedAmount;
          }, 0) / 12;
        const totalLeftAmount = structuredData.reduce((total, data) => {
          return total + data.leftAmount;
        }, 0);
        const totalAmount = structuredData.reduce((total, data) => {
          return total + data.totalAmount;
        }, 0);
        const totalAmountDivorce = structuredData.reduce((total, data) => {
          return total + data.totalDivorceAmount;
        }, 0);
        const totalAmountDivorceDiff = totalAmount - totalAmountDivorce;
        const totalNewBudget =
          structuredData.reduce((total, data) => {
            return total + data.newMonthlyBudget;
          }, 0) + totalUsedAmount;
        const totalDifference = totalUsedAmount - totalNewBudget;
        setTotalData({
          totalUsedAmount,
          totalLeftAmount,
          totalAmount,
          totalNewBudget,
          totalDifference,
          totalAmountDivorce,
          totalAmountDivorceDiff,
        });
      }

      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };

  useEffect(() => {
    getAllBudgets();
  }, []);

  return (
    <div
      className="summary-section-container"
      style={{ width: "100%", borderRadius: "8px", marginTop: "0px" }}
    >
      <div className="summary-section" style={{ padding: "8px" }}>
        <div className="total-summary-section">
          <h2 className="total-summary">Total</h2>
        </div>
        <div className="average-budget-summary-section">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              columnGap: "3px",
            }}
          >
            <h2 className="average-budget-summary">Average Budget</h2>
            <ToolTipCreator name={"Divorce_12-Month_Average_Monthly_Budget"} />
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: "4rem", alignItems: "center" }}>
        <div className="amount-spend-section">
          <div className="amount-spend-title-section">
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              <h2 className="spend-amount-title">Average Monthly Budget</h2>
              <ToolTipCreator name={"Divorce_Monthly_Budget"} />
            </div>
          </div>
          <div className="spend-amount-amount-section">
            <h2 className="spend-amount-amount" style={{ fontSize: "20px" }}>
              $
              {totalData && totalData.totalAmount
                ? formatAmount(totalData.totalAmount)
                : 0.0}
            </h2>
          </div>
        </div>
        <div className="saved-amount-section">
          <div className="saved-amount-title-section">
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              <h2 className="saved-amount-title">Post Divorce Budget</h2>
              <ToolTipCreator name={"Divorce_Post-Divorce_Budget"} />
            </div>
          </div>
          <div className="saved-amount-amount-section">
            <h2 className="saved-amount-amount" style={{ fontSize: "20px" }}>
              $
              {totalData && totalData.totalAmountDivorce
                ? formatAmount(totalData.totalAmountDivorce)
                : 0.0}
            </h2>
          </div>
        </div>
        <div className="exceeded-amount-section">
          <div className="exceeded-amount-title-section">
            <h2 className="exceeded-amount-title">Difference</h2>
          </div>
          <div className="exceeded-amount-section">
            <h2 className="exceeded-amount-amount" style={{ fontSize: "20px" }}>
              $
              {totalData && totalData.totalAmountDivorceDiff
                ? formatAmount(totalData.totalAmountDivorceDiff)
                : 0.0}
            </h2>
          </div>
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
